import React from 'react'
import styled, { css } from 'styled-components'
import { Props } from 'react-input-mask'
import { faEye } from '@fortawesome/pro-regular-svg-icons/faEye'
import { faEyeSlash } from '@fortawesome/pro-regular-svg-icons/faEyeSlash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { CustomIcon } from '.'
import Tooltip, { TooltipTrigger } from '../Tooltip'

interface Input {
  iconPosition: ('start' | 'end')[]
  error: boolean
  disabled: boolean
  showCharsAmount: boolean
}

export const InputWrapper = styled.div<Input>`
  position: relative;

  border: 1px solid ${({ error }) => `var(--${error ? 'red-500' : 'blueish-400'})`};
  border-radius: 8px;
  height: 40px;

  input {
    color: ${({ disabled }) => `var(--gray-${disabled ? 300 : 800})`};
    background-color: ${({ disabled }) => `var(--${disabled ? 'blueish-50' : 'gray-0'})`};
    padding-left: ${({ iconPosition }) => (iconPosition?.includes('start') ? '36px' : '16px')};
    padding-right: ${({ iconPosition, showCharsAmount }) =>
      showCharsAmount || iconPosition?.includes('end') ? '58px' : '16px'};
  }

  input:focus {
    outline: 2px solid ${({ error }) => `var(--${error ? 'red-500' : 'blueish-400'})`};
  }

  .chars-amount {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 10px;
    margin-top: auto;
    margin-bottom: auto;
    height: fit-content;
    color: var(--gray-300);
    font-size: 12px;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      border-color: var(--blueish-200);

      input {
        cursor: not-allowed;
      }

      svg {
        color: var(--gray-300);
      }
    `}
`

export const Input = styled.input<Partial<Props>>`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: none;
  border-radius: 8px;
  padding: 0 16px;

  &::placeholder {
    color: var(--gray-300);
  }
`

export const InputIcon = styled.div.attrs<CustomIcon>((props) => ({
  children: !!props?.tooltipText ? (
    <Tooltip placement="top" hasArrow description={props?.tooltipText} offsetValue={15}>
      <TooltipTrigger>
        <FontAwesomeIcon icon={props.icon} />
      </TooltipTrigger>
    </Tooltip>
  ) : (
    <FontAwesomeIcon icon={props.icon} />
  ),
}))<CustomIcon>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ color }) => (!!color ? `var(--${color}-500)` : 'var(--gray-400)')};
  position: absolute;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  ${({ positionAtEnd }) => (positionAtEnd ? 'right: 10px' : 'left: 10px')};

  svg {
    ${({ onClick }) => !!onClick && 'cursor: pointer'};
  }
`

export const VisibilityButton = styled.button.attrs<{ showPassword: boolean }>((props) => ({
  ...props,
  'aria-hidden': true,
  type: 'button',
  children: <FontAwesomeIcon icon={props.showPassword ? faEyeSlash : faEye} />,
}))<{ showPassword: boolean }>`
  position: absolute;
  top: 0;
  bottom: 0;
  margin-top: auto;
  margin-bottom: auto;
  right: 10px;
  height: 16px;
  width: 18px;

  padding: 0;
  border: 0;
  background-color: transparent;

  color: var(--blue-500);
  cursor: pointer;
`
